export function stringifyAfParameters(afParams) {
  var finalStr = '';

  for (var _i = 0, _Object$keys = Object.keys(afParams); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];

    if (afParams[key] !== null) {
      finalStr += "&".concat(key, "=").concat(afParams[key]);
    }
  }

  return finalStr;
}